var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"classList"},[_c('back-to'),_c('List',{ref:"changList",attrs:{"themeId":_vm.themeId,"ticketShow":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }